/**
 * Tour Steps Index
 * Exports step definitions for all tours
 * Supports role-based messaging for FMA tours (agent vs agency)
 */
import { Step } from "react-joyride";
import { TourId } from "@/global/contexts/TourContext";
import { dashboardSteps } from "./dashboard";
import { agentsSteps } from "./agents";
import { agenciesSteps } from "./agencies";
import { getFmaHomeSteps } from "./fmaHome";
import { fmaAgenciesSteps } from "./fmaAgencies";
import { getFmaTrainingSteps } from "./fmaTraining";
import { fmaAccountSteps } from "./fmaAccount";

export function getTourSteps(tourId: TourId, isAgent: boolean = true): Step[] {
  switch (tourId) {
    case "ams-main":
      return dashboardSteps;
    case "ams-agents":
      return agentsSteps;
    case "ams-agencies":
      return agenciesSteps;
    case "fma-home":
      return getFmaHomeSteps(isAgent);
    case "fma-agencies":
      return fmaAgenciesSteps;
    case "fma-training":
      return getFmaTrainingSteps(isAgent);
    case "fma-account":
      return fmaAccountSteps;
    default:
      return [];
  }
}
